// hooks/useContractCalculations.js
import { useState, useEffect, useMemo } from 'react';

export const useContractCalculations = (data, selectedUnits, selectedBuilding, dateMetrics) => {

    console.log("selectedUnits:", selectedUnits)

    const [calculationResults, setCalculationResults] = useState({
        rentAmount: 0,
        serviceCharge: 0,
        deposit: 0,
        ejariFee: 0,
        commissionFee: 0,
        parkingFee: 0,
        discount: 0,
        otherFee: 0,
        preSettled: 0,
        totalRent: 0,
        totalServiceCharge: 0,
        vatPercent: 5,
        serviceVatPercent: 5,
        vatAmount: 0,
        serviceVatAmount: 0,
        commissionVatAmount: 0,
        grossTotal: 0,
        totalIncome: 0,
        netIncome: 0,
        netRent: 0,
        netService: 0,
        netCommission: 0,
        totalUnitsCC: 0,
        rentForPeriod: 0,
        totalAllocation: 0
    });

    const totalUnitsCC = useMemo(() => {
        return selectedUnits.filter(unit => unit.UnitID || unit.unit_id).length;
    }, [selectedUnits]);

    const totalRentFromUnits = useMemo(() => {
        return selectedUnits.reduce((sum, unit) => sum + (Number(unit.MonthlyRent) || 0) / 12, 0);
    }, [selectedUnits]);

    const totalServiceFromUnits = useMemo(() => {
        return selectedUnits.reduce((sum, unit) => sum + (Number(unit.ServiceCharge) || 0), 0);
    }, [selectedUnits]);

    const calculate = () => {
        const contract = data.contract || {};

        const rentAmount = parseFloat(contract.rent) || 0;
        const serviceCharge = parseFloat(contract.serviceCharge) || 0;
        const deposit = parseFloat(contract.deposit) || 0;
        const ejariFee = parseFloat(contract.ejariFee) || 0;
        const commissionFee = parseFloat(contract.commissionFee) || 0;
        const parkingFee = parseFloat(contract.parkingFee) || 0;
        const discount = parseFloat(contract.discount) || 0;
        const otherFee = parseFloat(contract.otherFee) || 0;
        const preSettled = parseFloat(contract.preSettled) || 0;

        const isResidential = (contract.tenancyType || '').trim().toUpperCase() === 'RESIDENTIAL';
        const buildingVatPercent = parseFloat(selectedBuilding?.VATPercentage);
        const vatPercent = isResidential ? 0 : (isNaN(buildingVatPercent) ? 5 : buildingVatPercent);
        const serviceVatPercent = isResidential ? 0 : vatPercent;

        const years = dateMetrics.years || 0;
        const months = dateMetrics.months || 0;
        const days = dateMetrics.days || 0;
        const totalMonths = months + (years * 12);


        console.log("totalMonths:", totalMonths)
        console.log("years:", years)
        console.log("months:", months)
        console.log("Days:", days)

        let calculatedRent = 0;
        let calculatedService = 0;
        let parkingTotal = 0;

        selectedUnits.forEach(unit => {
            if (unit.UnitID || unit.unit_id) {
                const yearlyRent = Number(unit.MonthlyRent) || 0;
                const monthlyRent = yearlyRent / 12;
                const unitService = Number(unit.ServiceCharge) || 0;
                const unitParking = Number(unit.ParkingFee) || 0;

                const dailyRent = yearlyRent / 365;
                const dailyService = unitService / 365;

                calculatedRent += (dailyRent * totalMonths) + (dailyRent * days);
                calculatedService += (dailyService * totalMonths) + (dailyService * days);

                parkingTotal += unitParking;
            }
        });

        const finalRent = rentAmount > 0 ? rentAmount : calculatedRent;
        // 4500
        const finalService = serviceCharge > 0 ? serviceCharge : calculatedService;
        // 230
        const finalParking = parkingFee > 0 ? parkingFee : parkingTotal;
        // 400

        const rentVat = (finalRent * vatPercent) / 100;
        // (4500*5)/100  = 150
        const serviceVat = (finalService * serviceVatPercent) / 100;
        // (230*5)/100=11.5
        const commissionVat = (commissionFee * vatPercent) / 100;
        // 60*5/100=3
        const netRent = finalRent + rentVat;
        // 4500+225 =4725
        const netService = finalService + serviceVat;
        // 230+11.5=241.5
        const netCommission = commissionFee + commissionVat;
        // 60+3=63
        const grossTotal = finalRent + finalService + ejariFee + commissionFee + finalParking + otherFee;
        // 4500+230+200+60+400+100= 5,490
        const total = finalRent + finalService + commissionFee + finalParking + otherFee + deposit;
        const totalIncome = grossTotal - discount;
        // 5490-50 = 5,440
        const netIncome = totalIncome - preSettled;
        // 5,440-40 = 5400

        let rentForPeriod = 0;
        let serviceForPeriod = 0;
        selectedUnits.forEach(unit => {
            if (unit.UnitID || unit.unit_id) {
                const yearlyRent = Number(unit.MonthlyRent) || 0;
                const monthlyRent = yearlyRent / 12;
                // 4500/12 = 375
                const unitService = Number(unit.ServiceCharge) || 0;
                const dailyRent = yearlyRent / 365;
                const dailyService = unitService / 30;
                rentForPeriod += (monthlyRent * totalMonths) + (dailyRent * days);
                // 0+(375*12)+(0) =  4500
                serviceForPeriod += (unitService * totalMonths) + (dailyService * days);
            }
        });

        const results = {
            rentAmount: finalRent,
            serviceCharge: finalService,
            deposit,
            ejariFee,
            commissionFee,
            parkingFee: finalParking,
            discount,
            otherFee,
            preSettled,
            totalRent: finalRent,
            totalServiceCharge: finalService,
            totalUnitsCC,
            rentForPeriod: Math.round(rentForPeriod * 100) / 100,
            vatPercent,
            serviceVatPercent,
            vatAmount: Math.round(rentVat * 100) / 100,
            serviceVatAmount: Math.round(serviceVat * 100) / 100,
            commissionVatAmount: Math.round(commissionVat * 100) / 100,
            netRent: Math.round(netRent * 100) / 100,
            netService: Math.round(netService * 100) / 100,
            netCommission: Math.round(netCommission * 100) / 100,
            grossTotal: Math.round(grossTotal * 100) / 100,
            total: Math.round(total * 100) / 100,
            totalIncome: Math.round(totalIncome * 100) / 100,
            netIncome: Math.round(netIncome * 100) / 100,
            totalAllocation: Math.round((finalRent + finalService + ejariFee + commissionFee + finalParking) * 100) / 100,
            // 4500+230+200+60+400 = 5,390
        };

        setCalculationResults(results);
        return results;
    };

    useEffect(() => {
        if (selectedUnits.length > 0) {
            calculate();
        }
    }, [data.contract, selectedUnits, selectedBuilding, dateMetrics]);

    const calculateDebit = () => {
        const results = calculationResults;
        return {
            totalDebit: results.grossTotal || 0,
        };
    };

    return {
        calculationResults,
        totalUnitsCC,
        totalRentFromUnits,
        totalServiceFromUnits,
        calculate,
        calculateDebit,
        calculateUnits: () => totalUnitsCC,
        calculateUnitRent: () => ({
            unitRent: Math.round(totalRentFromUnits),
            unitCommission: Math.round(totalServiceFromUnits)
        })
    };
};
